/**
 * Utility functions for filtering thoughts
 */

/**
 * Filter thoughts based on active tag filters
 * @param {Array} thoughts - Array of thought objects
 * @param {Array} tagFilters - Array of tag strings to filter by
 * @returns {Array} - Filtered thoughts array
 */
export const filterThoughtsByTags = (thoughts, tagFilters = []) => {
  // If no filters are applied, return all thoughts
  if (!tagFilters || tagFilters.length === 0) {
    return thoughts;
  }

  // Only show thoughts that have at least one matching tag
  return thoughts.filter(thought => 
    thought.tags && 
    Array.isArray(thought.tags) && 
    thought.tags.some(tag => tagFilters.includes(tag))
  );
};

/**
 * Filter thoughts based on search term
 * @param {Array} thoughts - Array of thought objects 
 * @param {string} searchTerm - Term to search for
 * @returns {Array} - Filtered thoughts array
 */
export const filterThoughtsBySearchTerm = (thoughts, searchTerm = '') => {
  if (!searchTerm) {
    return thoughts;
  }
  
  const searchLower = searchTerm.toLowerCase();
  return thoughts.filter(thought => (
    thought.thought?.toLowerCase().includes(searchLower) ||
    (thought.theme && thought.theme.toLowerCase().includes(searchLower)) ||
    (thought.motif && thought.motif.toLowerCase().includes(searchLower)) ||
    (thought.tags && thought.tags.some(tag => tag.toLowerCase().includes(searchLower)))
  ));
}; 